import { render } from "./WCItemModifierQuantityEntry.vue?vue&type=template&id=3c4e2aba&scoped=true"
import script from "./WCItemModifierQuantityEntry.vue?vue&type=script&lang=js"
export * from "./WCItemModifierQuantityEntry.vue?vue&type=script&lang=js"

import "./WCItemModifierQuantityEntry.vue?vue&type=style&index=0&id=3c4e2aba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4e2aba"]])

export default __exports__